module.exports = __webpack_public_path__ + "img/chrome-cast.5ab9cfdb.svg";